function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7.969v7.968H10.437v-2.312H2.25V2.25h11.375V10.437h2.312V0H0v7.969zm22.75 1.125v1.156H25V7.938h-2.25v1.156zM8.758 8.768c-.417.42-.758.777-.758.794 0 .018 1.673 1.705 3.719 3.75a627.537 627.537 0 013.719 3.735c0 .008-.408.015-.907.015h-.906v2.25H19.312V13.626h-2.25v.906c0 .499-.007.906-.015.906-.009 0-1.69-1.673-3.735-3.718C11.268 9.673 9.576 8 9.556 8.003c-.022 0-.38.345-.797.765zm8.43.45v1.157h3.375V8.063h-3.376v1.156zm5.562 5v1.72H25V12.5h-2.25v1.719zm-15.938 3.97v1.125h2.25v-2.25H6.813v1.125zm15.938 1.125v1.125H25v-2.25h-2.25v1.125zM6.812 23.28V25h2.25V21.563H6.813v1.718zm4.563.594V25h2.25v-2.25h-2.25v1.125zm4.563 0V25h3.375v-2.25h-3.376v1.125zm5.624 0V25H25v-2.25H21.563v1.125z",
  fill: "#000"
});

function SvgInside(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInside);
export default __webpack_public_path__ + "static/media/inside.381bb264.svg";
export { ForwardRef as ReactComponent };